import { FC } from "react";
import { Dimension } from "../../../domain/models/metrics";
import { MonthView } from "./components/MonthView";
import { QuartersView } from "./components/QuartersView";
import { WeeksView } from "./components/WeeksView";
import { YearsView } from "./components/YearsView";
import { CalendarViewProps } from "./types";

export enum TimeRangeType {
  Weeks = "weeks",
  Months = "months",
  Quarters = "quarters",
  Years = "years",
}

export const SELECTED_TAB_COMPONENTS: Record<
  TimeRangeType,
  FC<CalendarViewProps>
> = {
  [TimeRangeType.Months]: MonthView,
  [TimeRangeType.Quarters]: QuartersView,
  [TimeRangeType.Years]: YearsView,
  [TimeRangeType.Weeks]: WeeksView,
};

export const TAB_TO_DIMENSION_MAP: Record<TimeRangeType, Dimension> = {
  [TimeRangeType.Months]: Dimension.MONTH,
  [TimeRangeType.Quarters]: Dimension.QUARTER,
  [TimeRangeType.Years]: Dimension.YEAR,
  [TimeRangeType.Weeks]: Dimension.WEEK,
};

export const DIMENSION_TO_TAB_MAP: Record<Dimension, TimeRangeType> = {
  [Dimension.MONTH]: TimeRangeType.Months,
  [Dimension.QUARTER]: TimeRangeType.Quarters,
  [Dimension.YEAR]: TimeRangeType.Years,
  [Dimension.WEEK]: TimeRangeType.Weeks,
};

export const BORDER_RADIUS = "12px";

export const today = new Date();
export const DEFAULT_END_DATE = new Date(
  Date.UTC(today.getFullYear(), today.getMonth() + 1, 0),
);
export const DEFAULT_START_DATE = new Date(
  Date.UTC(
    DEFAULT_END_DATE.getUTCFullYear(),
    DEFAULT_END_DATE.getUTCMonth() - 5,
    1,
  ),
);

export const DEFAULT_DIMENSION: Dimension = Dimension.MONTH;
/**
 * Earliest allowed date for user-level data (12 March 2024 00:00:00 UTC).
 * Sessions before this date are excluded per business rules.
 */
export const EARLIEST_DATA_DATE = new Date(Date.UTC(2024, 2, 12));

export const SELECTED_COUNTRIES_KEY = "selectedCountriesInternalUsage";
export const SELECTED_EXPERIENCES_KEY = "selectedExperiencesInternalUsage";
export const DIMENSION_KEY = "dimensionInsights";
export const START_DATE_KEY = "startDateInsights";
export const END_DATE_KEY = "endDateInsights";
export const MIN_SESSION_DURATION_KEY = "minSessionDurationInsights";
export const LICENSE_IDS_KEY = "licenseIdsExternalUsage";
export const SHOWING_OPTION_KEY = "showingOptionUserLevelData";

export const CUMULATIVE_CHARTS_FEATURE_FLAG = "uam_showCumulativeCharts";
